import {fromPairs, round} from 'lodash-es';

export function highestKey(object: { [key: number]: any }) {
    return Math.max(
        -1,
        ...Object.keys(object).map((x) => parseInt(x, 10)),
    );
}

export function isPositiveNumber(maybeNumber: any): boolean {
    return ! isNaN(maybeNumber) && maybeNumber > 0;
}

export function insertAfterKey<T>(object: T, previousKey: keyof T, newKey: string, value: T[keyof T]): T {
    const pairs = Object.entries(object) as Array<[string, T[keyof T]]>;
    const pairsIndex = pairs.findIndex(pair => pair[0] === previousKey);

    pairs.splice(pairsIndex + 1, 0, [newKey, value]);

    return fromPairs(pairs) as unknown as T;
}

export function parseDecimalNumber(maybeNumber: string, decimals: number|null = 2): number {
    const parsedNumber = parseFloat(maybeNumber.replace(',', '.'));

    if (decimals !== null) {
        return round(parsedNumber, decimals);
    }

    return parsedNumber;
}

export function shouldNotHappen(x: never): never {
    throw new Error('Encountered unhandled case, this is a bug!');
}
